export const BILLING_PATH = '/settings/billing';

const UPGRADE_MARKER = 'upgrade your plan';

export const isUpgradeError = (message?: string | null): boolean => {
    if (!message) return false;
    return message.toLowerCase().includes(UPGRADE_MARKER);
};
